export default {"src":"/_next/static/media/EncoreMieuxSigle.b6c34d61.svg","height":1074,"width":756,"blurWidth":0,"blurHeight":0};